jQuery(document).ready(function () {
  function paramsToObject(entries) {
    var result = {}
    for(var [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }

  function getPathname() {
    var result = window.location.pathname;
    // delete page from the pathname
    if (result.indexOf('/page/')) {
      var splitPathname = result.split('/');
      if (splitPathname && splitPathname.length > 0) {
        var findIndex = splitPathname.findIndex(function (c){ return c === 'page' });
        if (findIndex > -1) {
          splitPathname.splice(findIndex);
          if (splitPathname.length > 0) {
            var joinedPathname = splitPathname.join('/');
            if (joinedPathname) {
              return joinedPathname;
            }
          }
        }
      }
    }
    return result
  }

  function onChangeFilter() {
    var $this = jQuery(this);
    // var dateSelect = jQuery('.js-date-select');
    var selectName = $this.attr('name');
    var selectValue = $this.val();
    var tagValue;
    if(selectName === 'tags-mobile') {
      selectName = undefined;
      tagValue = selectValue;
    } else {
      tagValue = jQuery('.js-filter-tag:checked').val();
    }
    var pathname = getPathname();
    var search = window.location.search;

  
    var urlParams = new URLSearchParams(search);
    var entries = urlParams.entries(); 
    var params = paramsToObject(entries);

    if(selectName) {
      if (selectValue) {
        params[selectName] = selectValue;
      } else {
        delete params[selectName];
      }
    }

    if (tagValue) {
      params.tag = tagValue;
    } else {
      delete params.tag;
    }
    var searchParams = new URLSearchParams();

    Object.keys(params).forEach(key => searchParams.append(key, params[key]));
    var resultQueryParams = searchParams.toString();
    console.log(resultQueryParams, 'resultQueryParams');
    var resultPathname = pathname + '?' + resultQueryParams;
    window.location = resultPathname;
    
  }

  
  jQuery(".js-filter-select").change(onChangeFilter);
  jQuery(".js-filter-tag").change(onChangeFilter);
});
